export default "__VITE_ASSET__5807e9cf__"